import React, { useEffect } from 'react';
import { ArrowForward, Share } from '@mui/icons-material'; // Import MUI icons
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS CSS
import { useProjectContext } from '../../context/ProjectContext';
import { Banner } from '../../assets/images';
import { Link, useNavigate } from 'react-router-dom';
import { shareProject } from '../../components/Home/DynamicSection';

interface BannerProps {}

const Projects: React.FC = () => {
  const { projects } = useProjectContext(); // Get the projects from context
  const navigate = useNavigate();

  // Initialize AOS for animation
  useEffect(() => {
    // Initialize AOS for animations
    AOS.init({ duration: 1000 });

    // Scroll to top on initial load
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className='mx-auto'>
      {/* Top Banner Section */}
      <div
        className="h-[344px] px-4 md:px-8 pt-[100px] pb-[63px] flex flex-col justify-center items-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${Banner})`, // Use the background image for the top banner
        }}
      >
        <div className="text-center text-white text-4xl font-bold font-['Tajawal'] leading-[50.40px]">
          {'مشاريعنا'}
        </div>
      </div>

      {/* Projects Preview Section */}
      <div className="px-4 md:px-24 py-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 m-auto md:mx-12 md:p-12">
        {projects.length > 0 ? (
          projects.map((project, index) => (
       <Link to={`/project/${project.id}`}
                key={project.id}
                className="relative group  overflow-hidden   "
              >
                <img
                  src={project.image || 'https://via.placeholder.com/400'}
                  alt={project.name}
                  className="w-full h-full object-contain transform transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-between p-4">
                  <h3 className="text-xl font-bold text-white">{project.name}</h3>
                  <div className="flex gap-4">
                    <button
                      onClick={() => navigate(`/project/${project.id}`)}
                      className="flex items-center gap-2 text-white bg-[#baad87] py-2 px-4 rounded-full hover:bg-[#a08e6e] transition"
                    >
                      عرض المشروع
                      <ArrowForward />
                    </button>
                    <button
                      onClick={() => shareProject(`${window.location.origin}/project/${project.id}`)}
                      className="flex items-center gap-2 text-white bg-gray-700 py-2 px-4 rounded-full hover:bg-gray-600 transition"
                    >
                      مشاركة
                      <Share />
                    </button>
                  </div>
                </div>
              </Link>
          ))
        ) : (
          <p className="text-center text-white">No projects available.</p>
        )}
      </div>

      {/* Share Icon Section */}
      <div className="flex justify-center py-4">
        <Share className="text-black text-3xl font-black" />
      </div>
    </div>
  );
};

export default Projects;
